$(function(){

    const apiURL = $('.work-plugin').attr('data-api-url');

    if (apiURL) {
        const $selfConsumptionDegree = $('.work-plugin__meta-value--self_consumption_degree');
        const $selfConsumption = $('.work-plugin__meta-value--self_consumption');
        const $autarkieDegree = $('.work-plugin__meta-value--autarkie_degree');

        $.ajax({
            dataType: "json",
            url: apiURL,
            success: function(data) {
                const values = data.data[0];
                $selfConsumptionDegree.text(`${values.ratioOwnConsumption}%`);
                $selfConsumption.text(`${values.ownConsumption.toLocaleString('de-CH')} ${$selfConsumption.attr('data-unit')}`);
                $autarkieDegree.text(`${values.autarchy}%`);
            }
          });
    }

});



// WEBPACK FOOTER //
// ./static/js/modules/references.js